export default function MuiFormLabel(theme) {
    console.log('✅ MuiFormLabel override applied');

    return {
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    color: theme.palette.text.primary,
                },
            },
        },
    };
}
